import * as Types from './actionTypes';

export const notifySIgnedup = (companyCode, headers) => ({
  type: Types.NOTIFY_SIGNUP,
  payload: {
    companyCode,
    headers,
  },
});

export const confirmSignup = (username, code) => ({
  type: Types.CONFIRM_SIGNUP,
  payload: {
    username,
    code,
  },
});

export const resendVerficationCode = (username) => ({
  type: Types.RESEND_VERIFICATION_CODE,
  payload: {
    username,
  },
});

export const login = (username, password, accountType, signingup) => ({
  type: Types.LOGIN,
  payload: {
    username,
    password,
    accountType,
    signingup,
  },
});

export const resetPassowrd = (username, code, password) => ({
  type: Types.RESET_PASSWORD,
  payload: {
    username,
    code,
    password,
  },
});

export const forgotPassword = (username) => ({
  type: Types.FORGOT_PASSWORD,
  payload: {
    username,
  },
});

export const signup = (values) => ({
  type: Types.SIGNUP,
  payload: {
    values,
  },
});
